import { createContext } from 'react';

// guest user context
export const Context = createContext(null);
 
// logged in user context
export const UserContext = createContext(null);
